export interface UserDetails {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  location: Location | null;
  birthDate: string;
  consentEmail: boolean;
  consentMessaging: boolean;
  password?: string | undefined;
  retypePassword?: string | undefined;
}

export const DefaultUserDetails: UserDetails = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  location: null,
  birthDate: '',
  consentEmail: false,
  consentMessaging: false,
  password: undefined,
  retypePassword: undefined,
};

export interface Location {
  latitude: number;
  longitude: number;
  countryCode: string | null;
  city: string | null;
}

export interface CollectFields {
  firstName: boolean;
  lastName: boolean;
  email: boolean;
  location: boolean;
  phoneNumber: boolean;
  birthDate: boolean;
  password: boolean;
  consentEmail: boolean;
  consentMessaging: boolean;
}

export interface RequiredRules {
  firstName: boolean;
  lastName: boolean;
  email: boolean;
  location: boolean;
  phoneNumber: boolean;
  birthDate: boolean;
  password: boolean;
  consentEmail: boolean;
  consentMessaging: boolean;
}

export interface UserDetailsFormProps {
  initialValues?: Partial<UserDetails>;
  disabled?: boolean;
  emailDisabled?: boolean;
  canChangeEmail?: boolean;
  collectFields?: Partial<CollectFields>;
  requiredRules?: Partial<RequiredRules>;
  consentEmailLabel?: string;
  consentMessagingLabel?: string;
  submitButtonText?: string;
  error?: string;
  success?: string;
  isSubmitting?: boolean;
  isLoading?: boolean;
}

export const DefaultUserDetailsForm = {
  initialValues: () => DefaultUserDetails,
  disabled: false,
  emailDisabled: false,
  canChangeEmail: false,
  collectFields: () => ({
    firstName: false,
    lastName: false,
    email: false,
    location: false,
    phoneNumber: false,
    birthDate: false,
    password: false,
    consentEmail: false,
    consentMessaging: false,
  }),
  requiredRules: () => ({
    firstName: true,
    lastName: true,
    email: true,
    location: true,
    phoneNumber: true,
    birthDate: true,
    password: true,
    consentEmail: true,
    consentMessaging: true,
  }),
  submitButtonText: '',
  error: '',
  success: '',
  isSubmitting: false,
  isLoading: false,
};
